import { getSectionBackgroundStyle, useMediaQuery } from 'academy-common-lib/utils/Styling';
import usageTracker from '../../../utils/usageTracker';
import ACInstructorCard from 'academy-common-lib/components/card/ACInstructorCard';
import ACHorizontalScrollContainer from 'academy-common-lib/components/container/ACHorizontalScrollContainer';
import { H2 } from 'foundations-components/transitional/components/H2';
import FormattedMessage from 'I18n/components/FormattedMessage';
import styled from 'foundations-theming/utils';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProfessorSection = styled.section.withConfig({
  displayName: "PublicPageProfessorsSection__ProfessorSection",
  componentId: "bijk2a-0"
})(["", ""], ({
  theme: trellisTheme
}) => getSectionBackgroundStyle(trellisTheme.color['fill-surface-raised']));
const PublicPageProfessorsSection = ({
  professors,
  contentType,
  lessonId,
  trackId
}) => {
  const {
    isMobile
  } = useMediaQuery();
  if (!(professors !== null && professors !== void 0 && professors.length)) return null;
  const trackProfessorClick = (professorId, organisation, organisationUrl) => () => {
    usageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType,
      appearsIn: 'public-landing-page',
      organisation,
      organisationUrl,
      professorId,
      lessonId,
      trackId
    });
  };
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(ProfessorSection, {
      children: /*#__PURE__*/_jsxs(View, {
        "data-test-id": "public-page-professors-section",
        paddingBlockEnd: "900",
        paddingBlockStart: "1100",
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.instructors.heading"
          })
        }), /*#__PURE__*/_jsx(ACHorizontalScrollContainer, {
          children: /*#__PURE__*/_jsx(Flex, {
            flexDirection: isMobile ? 'column' : 'row',
            gap: "400",
            children: professors.map(professor => {
              const {
                id,
                description,
                professorImage,
                jobTitle,
                name,
                organisation,
                organisationUrl
              } = professor;

              // Mobile or single professor: 100% width, Multiple desktop: responsive calc pattern
              return /*#__PURE__*/_jsx(View, {
                flexBasis: isMobile || professors.length === 1 ? '100%' : 'calc(min(850px, 100vw) * 0.8)',
                flexShrink: "0",
                children: /*#__PURE__*/_jsx(ACInstructorCard, {
                  description: description || '',
                  imageUrl: professorImage || '',
                  jobTitle: jobTitle,
                  name: name || '',
                  onClick: () => trackProfessorClick(id.toString(), organisation || '', organisationUrl || ''),
                  organisationName: organisation,
                  organisationUrl: organisationUrl
                })
              }, id);
            })
          })
        })]
      })
    })
  );
};
export default PublicPageProfessorsSection;